import {
  DEPRECATED_backwardsCompatibleValues,
  StrictLocalizeFunction,
} from "@faire/web--source/common/localization/localize";

export const marketSpecialsToggleFilter = "maker_special:toggle";

export const getMarketNavLinkInfo = (
  linkName: string | undefined,
  linkTo: string | undefined,
  strictLocalize: StrictLocalizeFunction
) => {
  let marketLinkTo = "";
  if (linkTo) {
    marketLinkTo = getMarketNavLinkUrl(linkTo);
  }
  return {
    marketLinkName: strictLocalize(
      {
        defaultMessage: "{categoryName} Specials",
        description: {
          text: "Specials are promos related to the category that the retailer has selected. For example if the category is Jewelry, then it would be 'Jewelry Specials'",
        },
      },
      DEPRECATED_backwardsCompatibleValues({
        categoryName: linkName,
      })
    ),
    marketLinkTo: marketLinkTo,
  };
};

export const getMarketNavLinkUrl = (linkTo: string) => {
  const marketQueryParamAndFilters = `market=1&filters=${marketSpecialsToggleFilter}`;
  return (
    linkTo + (linkTo.includes("?") ? "&" : "?") + marketQueryParamAndFilters
  );
};

export const LOAD_UPCOMING_PROMO_HEADER: Record<string, string> = {
  "X-LOAD-UPCOMING-MARKET-BRAND-PROMO": "LOAD-UPCOMING-MARKET-BRAND-PROMO",
};
